// Analytics for product-selector, product-locator, product-locator-ff, recommendation-wizard

analytics.eventConfig.push(
    {
        "target": "*",
        "codeId": "c04",
        "events": [
            {
                "eventTarget": ":not(.form-submit)[data-bs-toggle*=modal], .product-locator search-results [data-bs-toggle*=modal], .product-locator-ff search-results [data-bs-toggle*=modal]",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "lightbox",
                    "componentId": "c04",
                    "eventType": "lightbox load click",
                    "elementType": [
                        {
                            "rule": "$(context).hasClass('btn')",
                            "value": "lightbox button"
                        },
                        {
                            "rule": "true",
                            "value": "lightbox link"
                        }
                    ],
                    "elementText": "",
                    "destinationUrl": "",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            }
        ]
    },
    // Product Locator components
    {
        "target": ".product-locator",
        "events": [

            {
                "eventTarget": ".suggestLink",
                "eventType": "click",
                "tags": {
                    "componentId": "lsb",
                    "componentName": "locator search box",
                    "elementText": "",
                    "elementType": "locator search box",
                    "event": "locator",
                    "eventType": "locator search submit",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "region-selector select",
                "eventType": "change",
                "tags": {
                    "componentId": "lcd",
                    "componentName": "locator country dropdown",
                    "elementText": "",
                    "elementType": "locator country select box",
                    "event": "locator",
                    "eventType": "locator country selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "search-results a[href^='mailto']:not(.btn):not(.buy-online-link),search-results a[href^='tel']:not(.btn):not(.buy-online-link)",
                "eventType": "click",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "email link"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "phone number link"
                        }
                    ],
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "location click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "location click to call"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results table a[data-analytics=contact], search-results .search-results-gdl .product-list-description a[data-analytics=contact]",
                "eventType": "click",
                "tags": {
                    "componentId": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "lwl"
                        },
                        {
                            "rule": "true",
                            "value": "lcl"
                        }
                    ],
                    "componentName": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "locator website link"
                        },
                        {
                            "rule": "true",
                            "value": "locator contact link"
                        }
                    ],
                    "elementType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website link"
                        },
                        {
                            "rule": "true",
                            "value": "phone number link"
                        }
                    ],
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "location click to call"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": "",
                    "destinationUrl": "",
                    "elementText": "",
                }
            },
            {
                "eventTarget": "search-results .gdlResultContainer a[data-analytics=contact]",
                "eventType": "click",
                "tags": {
                    "componentId": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "lwl"
                        },
                        {
                            "rule": "true",
                            "value": "lcl"
                        }
                    ],
                    "componentName": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "locator website link"
                        },
                        {
                            "rule": "true",
                            "value": "locator contact link"
                        }
                    ],
                    "elementType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website link"
                        },
                        {
                            "rule": "true",
                            "value": "phone number link"
                        }
                    ],
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "location click to call"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": "",
                    "destinationUrl": "",
                    "elementText": "",
                }
            },
            // New UI GDL Get direction
            {
                "eventTarget": ".gdlLocatorIcon",
                "eventType": "click",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "locator directions link",
                    "elementText": "",
                    "elementType": "directions link",
                    "event": "locator",
                    "eventType": "directions outbound click",
                    "destinationUrl": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "searchType": "",
                    "searchSubType": "",
                    "searchTerm": "",
                    "titleText": "",
                }
            },
            // New UI GDL company email
            {
                "eventTarget": "search-results .company_email",
                "eventType": "click",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementText": "",
                    "elementType": "email link",
                    "event": "locator",
                    "eventType": "location click to email",
                    "destinationUrl": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "searchType": "",
                    "searchSubType": "",
                    "searchTerm": "",
                }
            },
            // GDL company email
            {
                "eventTarget": "search-results .company_gdl_email",
                "eventType": "click",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementText": "",
                    "elementType": "email link",
                    "event": "locator",
                    "eventType": "location click to email",
                    "destinationUrl": "",
                    "parentListSource": "",
                    "parentName": "",
                    "parentTitle": "",
                    "searchType": "",
                    "searchSubType": "",
                    "searchTerm": "",
                }
            },
            {
                "eventTarget": "map",
                "eventType": "telClick",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementType": "phone number link",
                    "event": "locator",
                    "eventType": "location click to call",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results a:not([href^='mailto'],[href^='tel']):not(.btn):not(.buy-online-link):not(.directionText):not([data-analytics=contact]):not(.gdlLocatorIcon):not(.company_email):not(.company_gdl_email)",
                "eventType": "click",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "false",
                            "value": "locator logo link"
                        },
                        {
                            "rule": "true",
                            "value": "location title link"
                        }
                    ],
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "linkClick",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location details link",
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            }, {
                "eventTarget": "map",
                "eventType": "titleClick",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location title link",
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "#searchContainer .locator-search",
                "eventType": "click",
                "tags": {
                    "componentId": "lsb",
                    "componentName": "locator search box",
                    "elementText": "",
                    "elementType": "locator search box",
                    "event": "locator",
                    "eventType": "locator search submit",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "onResultsFetched",
                "eventType": "click",
                "tags": {
                    "componentId": "lrl",
                    "componentName": "locator results list",
                    "elementText": "",
                    "elementType": "locator search results list",
                    "event": "locator",
                    "eventType": "locator search results return",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-by-order button",
                "eventType": "click",
                "tags": {
                    "componentId": "lsd",
                    "componentName": "locator sort dropdown",
                    "elementText": "",
                    "elementType": "arrow icon",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).data('icon') === 'chevron-up' || $(context).find('[data-icon=chevron-up]').length",
                            "value": "sort ascending click"
                        },
                        {
                            "rule": "true",
                            "value": "sort descending click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-by-filter",
                "eventType": "change",
                "tags": {
                    "componentId": "lsd",
                    "componentName": "locator sort dropdown",
                    "elementText": "",
                    "elementType": "sort select box",
                    "event": "locator",
                    "eventType": "sort selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },

            {
                "eventTarget": "search-results .directionText[target=_blank]:not(.btn-secondary)",
                "eventType": "click",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results .btn-secondary .directionText",
                "eventType": "click",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results .btn-secondary.directionText",
                "eventType": "click",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "dirClick",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results .form-submit",
                "eventType": "click",
                "tags": {
                    "componentId": "llf",
                    "componentName": "locator leave feedback",
                    "elementText": "",
                    "elementType": "leave feedback button",
                    "event": "locator",
                    "eventType": "location leave feedback click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".buy-online-link",
                "eventType": "click",
                "tags": {
                    "componentId": "loo",
                    "componentName": "locator order online link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "order online button",
                    "event": "locator",
                    "eventType": "location order online outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "pinClick",
                "tags": {
                    "componentId": "sp01",
                    "componentName": "map",
                    "elementType": "locator map",
                    "event": "locator",
                    "eventType": "map pin click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            { // LBD dropdown
                "eventTarget": "franchise-filter select",
                "eventType": "change",
                "tags": {
                    "componentId": "lbd",
                    "componentName": "locator brand dropdown",
                    "elementText": "",
                    "elementType": "brand select box",
                    "event": "locator",
                    "eventType": "brand filter selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".form-amenities > input",
                "eventType": "click",
                "tags": {
                    "componentId": "lf",
                    "componentName": "locator facet",
                    "elementText": "",
                    "elementType": "search filter selection box",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).is(':checked')",
                            "value": "locator filter selection click"
                        },
                        {
                            "rule": "true",
                            "value": "locator filter deselection click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            // KHWS facet
            {
                "eventTarget": "checkbox-filter input",
                "eventType": "click",
                "tags": {
                    "componentId": "lf",
                    "componentName": "locator facet",
                    "elementText": "",
                    "elementType": "search filter selection box",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).is(':checked')",
                            "value": "locator filter selection click"
                        },
                        {
                            "rule": "true",
                            "value": "locator filter deselection click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "view-toggle .btn",
                "eventType": "click",
                "tags": {
                    "componentId": "lvt",
                    "componentName": "locator view toggle",
                    "elementText": "",
                    "elementType": "toggle button",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).attr('value') === 'List view'",
                            "value": "list toggle click"
                        },
                        {
                            "rule": "true",
                            "value": "map toggle click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-component > div:not(.sort-results-by)",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).hasClass('form-check-inline') || $(context).parent().hasClass('form-check-inline')",
                            "value": "location service radio button"
                        },
                        {
                            "rule": "true",
                            "value": "location service link"
                        }
                    ],
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".header-aviation .aviation-links a",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service link",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".header-aviation .aviation-options .form-check-inline",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service radio button",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "websiteClick",
                "tags": {
                    "componentId": "lwl",
                    "componentName": "locator website link",
                    "elementText": "",
                    "elementType": "location website link",
                    "event": "locator",
                    "eventType": "location website outbound click",
                    "destinationUrl": "",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".pvlrow .btn",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service button",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".distributor a",
                "eventType": "click",
                "tags": {
                    "componentId": "lfl",
                    "componentName": "locator footer link",
                    "elementText": "",
                    "elementType": "locator footer link",
                    "event": "locator",
                    "eventType": "locator footer internal navigation click",
                    "destinationUrl": ""
                }
            },
            {
                "eventTarget": "onInvoiceClick",
                "eventType": "click",
                "tags": {
                    "componentId": "li",
                    "componentName": "locator invoice button click",
                    "elementText": "",
                    "elementType": "invoice button",
                    "event": "locator",
                    "eventType": "invoice outbound click",
                    "destinationUrl": "",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            }
        ]
    },
    // new product locator components
    {
        "target": ".product-locator-ff",
        "events": [
            {
                "eventTarget": "searchIconClick",
                "eventType": "click",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementType": "location details link",
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".suggestLink",
                "eventType": "click",
                "tags": {
                    "componentId": "lsb",
                    "componentName": "locator search box",
                    "elementText": "",
                    "elementType": "locator search box",
                    "event": "locator",
                    "eventType": "locator search submit",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "region-selector select",
                "eventType": "change",
                "tags": {
                    "componentId": "lcd",
                    "componentName": "locator country dropdown",
                    "elementText": "",
                    "elementType": "locator country select box",
                    "event": "locator",
                    "eventType": "locator country selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "search-results a[href^='mailto']:not(.btn):not(.buy-online-link),search-results a[href^='tel']:not(.btn):not(.buy-online-link)",
                "eventType": "click",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "email link"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "phone number link"
                        }
                    ],
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "location click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('tel')",
                            "value": "location click to call"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results table a[data-analytics=contact]",
                "eventType": "click",
                "tags": {
                    "componentId": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "lwl"
                        },
                        {
                            "rule": "true",
                            "value": "lcl"
                        }
                    ],
                    "componentName": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "locator website link"
                        },
                        {
                            "rule": "true",
                            "value": "locator contact link"
                        }
                    ],
                    "elementType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website link"
                        },
                        {
                            "rule": "true",
                            "value": "phone number link"
                        }
                    ],
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).text().indexOf('http') > -1",
                            "value": "location website outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "location click to call"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": "",
                    "destinationUrl": "",
                    "elementText": "",
                }
            },
            {
                "eventTarget": "map",
                "eventType": "telClick",
                "tags": {
                    "componentId": "lcl",
                    "componentName": "locator contact link",
                    "elementType": "phone number link",
                    "event": "locator",
                    "eventType": "location click to call",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results a:not([href^='mailto'],[href^='tel']):not(.btn):not(.buy-online-link):not(.directionText):not([data-analytics=contact])",
                "eventType": "click",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "false",
                            "value": "locator logo link"
                        },
                        {
                            "rule": "true",
                            "value": "location title link"
                        }
                    ],
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "linkClick",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location details link",
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            }, {
                "eventTarget": "map",
                "eventType": "titleClick",
                "tags": {
                    "componentId": "ldl",
                    "componentName": "location detail link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "location title link",
                    "event": "locator",
                    "eventType": "location detail internal navigation click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "#searchContainer #searchbuttonnewlocator",
                "eventType": "click",
                "tags": {
                    "componentId": "lsb",
                    "componentName": "locator search box",
                    "elementText": "",
                    "elementType": "locator search box",
                    "event": "locator",
                    "eventType": "locator search submit",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "onResultsFetched",
                "eventType": "click",
                "tags": {
                    "componentId": "lrl",
                    "componentName": "locator results list",
                    "elementText": "",
                    "elementType": "locator search results list",
                    "event": "locator",
                    "eventType": "locator search results return",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-by-order button",
                "eventType": "click",
                "tags": {
                    "componentId": "lsd",
                    "componentName": "locator sort dropdown",
                    "elementText": "",
                    "elementType": "arrow icon",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).data('icon') === 'chevron-up' || $(context).find('[data-icon=chevron-up]').length",
                            "value": "sort ascending click"
                        },
                        {
                            "rule": "true",
                            "value": "sort descending click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-by-filter",
                "eventType": "change",
                "tags": {
                    "componentId": "lsd",
                    "componentName": "locator sort dropdown",
                    "elementText": "",
                    "elementType": "sort select box",
                    "event": "locator",
                    "eventType": "sort selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },

            {
                "eventTarget": "search-results .directions-btn[type=button]:not(.btn-secondary)",
                "eventType": "click",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "search-results .btn-secondary .directionText",
                "eventType": "click",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "dirClick",
                "tags": {
                    "componentId": "lgd",
                    "componentName": "locator get directions cta",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "get directions link",
                    "event": "locator",
                    "eventType": "get directions outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".buy-online-link",
                "eventType": "click",
                "tags": {
                    "componentId": "loo",
                    "componentName": "locator order online link",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "order online button",
                    "event": "locator",
                    "eventType": "location order online outbound click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": "map, .sp01-map",
                "eventType": "pinClick",
                "tags": {
                    "componentId": "sp01",
                    "componentName": "map",
                    "elementType": "locator map",
                    "event": "locator",
                    "eventType": "map pin click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            { // LBD dropdown
                "eventTarget": "franchise-filter select",
                "eventType": "change",
                "tags": {
                    "componentId": "lbd",
                    "componentName": "locator brand dropdown",
                    "elementText": "",
                    "elementType": "brand select box",
                    "event": "locator",
                    "eventType": "brand filter selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".form-amenities > input",
                "eventType": "click",
                "tags": {
                    "componentId": "lf",
                    "componentName": "locator facet",
                    "elementText": "",
                    "elementType": "search filter selection box",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).is(':checked')",
                            "value": "locator filter selection click"
                        },
                        {
                            "rule": "true",
                            "value": "locator filter deselection click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            // KHWS facet
            {
                "eventTarget": "checkbox-filter input",
                "eventType": "click",
                "tags": {
                    "componentId": "lf",
                    "componentName": "locator facet",
                    "elementText": "",
                    "elementType": "search filter selection box",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).is(':checked')",
                            "value": "locator filter selection click"
                        },
                        {
                            "rule": "true",
                            "value": "locator filter deselection click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "view-toggle .btn",
                "eventType": "click",
                "tags": {
                    "componentId": "lvt",
                    "componentName": "locator view toggle",
                    "elementText": "",
                    "elementType": "toggle button",
                    "event": "locator",
                    "eventType": [
                        {
                            "rule": "$(context).attr('value') === 'List view'",
                            "value": "list toggle click"
                        },
                        {
                            "rule": "true",
                            "value": "map toggle click"
                        }
                    ],
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".sort-component > div:not(.sort-results-by)",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).hasClass('form-check-inline') || $(context).parent().hasClass('form-check-inline')",
                            "value": "location service radio button"
                        },
                        {
                            "rule": "true",
                            "value": "location service link"
                        }
                    ],
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".header-aviation .aviation-links a",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service link",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".header-aviation .aviation-options .form-check-inline",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service radio button",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "map",
                "eventType": "websiteClick",
                "tags": {
                    "componentId": "lwl",
                    "componentName": "locator website link",
                    "elementText": "",
                    "elementType": "location website link",
                    "event": "locator",
                    "eventType": "location website outbound click",
                    "destinationUrl": "",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".pvlrow .btn",
                "eventType": "click",
                "tags": {
                    "componentId": "lstc",
                    "componentName": "locator search type change",
                    "elementText": "",
                    "elementType": "location service button",
                    "event": "locator",
                    "eventType": "location service selection click",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".distributor a",
                "eventType": "click",
                "tags": {
                    "componentId": "lfl",
                    "componentName": "locator footer link",
                    "elementText": "",
                    "elementType": "locator footer link",
                    "event": "locator",
                    "eventType": "locator footer internal navigation click",
                    "destinationUrl": ""
                }
            },
            {
                "eventTarget": "onInvoiceClick",
                "eventType": "click",
                "tags": {
                    "componentId": "li",
                    "componentName": "locator invoice button click",
                    "elementText": "",
                    "elementType": "invoice button",
                    "event": "locator",
                    "eventType": "invoice outbound click",
                    "destinationUrl": "",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": "",
                    "titleText": ""
                }
            }
        ]
    },
    {
        "target": ".product-locator",
        "codeId": "syl",
        "events": [
            {
                "eventTarget": "allow-location",
                "eventType": "click",
                "tags": {
                    "event": "locator",
                    "componentName": "share your location",
                    "componentId": "syl",
                    "elementText": "allow",
                    "eventType": "locator",
                    "elementType": "location allowed in browser"
                }
            },
        ]
    },
    {
        "target": ".product-locator",
        "codeId": "syl",
        "events": [
            {
                "eventTarget": "block-location",
                "eventType": "click",
                "tags": {
                    "event": "locator",
                    "componentName": "share your location",
                    "componentId": "syl",
                    "elementText": "block",
                    "eventType": "locator",
                    "elementType": "location blocked in browser"
                }
            },
        ]
    },
    {
        "target": ".product-locator-ff",
        "codeId": "syl",
        "events": [
            {
                "eventTarget": "allow-location",
                "eventType": "click",
                "tags": {
                    "event": "locator",
                    "componentName": "share your location",
                    "componentId": "syl",
                    "elementText": "allow",
                    "eventType": "locator",
                    "elementType": "location allowed in browser"
                }
            },
        ]
    },
    {
        "target": ".product-locator-ff",
        "codeId": "syl",
        "events": [
            {
                "eventTarget": "block-location",
                "eventType": "click",
                "tags": {
                    "event": "locator",
                    "componentName": "share your location",
                    "componentId": "syl",
                    "elementText": "block",
                    "eventType": "locator",
                    "elementType": "location blocked in browser"
                }
            },
        ]
    },
    // product selector - all variations
    {
        "target": ".component.product-selector",
        "codeId": "psall",
        "events": [
            {
                "eventTarget": "triggerOnNavigateToRecommendation",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "view recommendation auto navigation",
                    "event": "product",
                    "eventType": "view recommendations internal navigation click",
                    "searchFacets": ""
                }
            }, {
                "eventTarget": "triggerNavigateToRecommendationAutoSuggest",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "view recommendation auto navigation",
                    "event": "product",
                    "eventType": "view recommendations internal navigation click",
                    "searchFacets": ""
                }
            }, {
                "eventTarget": "onCategoryIconClick",
                "eventType": "click",
                "tags": {
                    "componentId": "fo02",
                    "componentName": "select box",
                    "elementText": "",
                    "elementType": "icon select box",
                    "event": "product",
                    "eventType": "ps icon selection click",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".iconsContainer a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentName": "select box",
                    "componentId": "fo02",
                    "eventType": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "outbound click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }

                    ],
                    "event": [
                        {
                            "rule": "$(context).prop('hostname') !== window.location.hostname",
                            "value": "outbound"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        },

                    ],
                    "elementText": "",
                    "elementType": "icon select box link",
                    "titleText": "",
                    "destinationUrl": "",
                    "anchorTag": "anchor-link"
                }
            },
            {
                "eventTarget": "a:not([href^=\\#],[href*=\\http]):not([href*='javascript:void(0)'])",
                "eventType": "click",
                "tags": {
                    "componentName": "select box",
                    "componentId": "fo02",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "select box internal navigation click"
                        }

                    ],
                    "event": [
                        {
                            "rule": "true",
                            "value": "navigation"
                        },
                    ],
                    "elementText": "",
                    "elementType": "icon select box link",
                    "destinationUrl": "",
                    "anchorTag": "anchor-link",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".cant-find-contact.tell-us",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tell us link",
                    "event": "navigation",
                    "eventType": "tell us lightbox load click"
                }
            },
            {
                "eventTarget": ".cant-find-contact.top a",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tell us link",
                    "event": "navigation",
                    "eventType": "tell us lightbox load click"
                }
            },
            {
                "eventTarget": ".selector-search .search",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "elementText": "search",
                    "elementType": "product selector search box",
                    "event": "product",
                    "eventType": "product selector search submit",
                    "titleText": ""
                }
            },
            {
                "eventTarget": ".button-contact-container .btn-primary",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "view recommendation button",
                    "event": "product",
                    "eventType": "view recommendations internal navigation click",
                    "searchFacets": ""
                }
            },
            {
                "eventTarget": ".cant-find-contact.bottom a",
                "eventType": "click",
                "tags": {
                    "componentId": "psall",
                    "componentName": "product selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tell us link",
                    "event": "navigation",
                    "eventType": "tell us lightbox load click"
                }
            },
            // BazaarVoice
            {
                "eventTarget": ".BVRRRatingSummaryLink a",
                "eventType": "click",
                "tags": {
                    "componentId": "psbv",
                    "componentName": "bazaarvoice",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType":
                        [
                            {
                                "rule": "$(context).data('analytics')  === 'bazaarvoice'",
                                "value": "bazaarvoice write review link"
                            },
                            {
                                "rule": "true",
                                "value": "bazaarvoice all reviews link"
                            }
                        ],
                    "event": "navigation",
                    "eventType": [
                        {
                            "rule": "$(context).data('analytics')  === 'bazaarvoice'",
                            "value": "write a review internal navigation click"
                        },
                        {
                            "rule": "true",
                            "value": "read all reviews internal navigation click"
                        }
                    ],
                    "highlyRec": "",
                    "parentName": "tabs",
                    "parentTitle": "",
                    "refinementCategory": "",
                    "starRating": "",
                    "titleText": ""
                }
            }
        ]
    },
    {
        "target": ".product-selector",
        "codeId": "ldcl",
        "events": [
            {
                "eventTarget": ".showProd",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "recommendation list refinement",
                    "event": "navigation",
                    "refinementCategory": "",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "show products click"
                        }
                    ],
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
        ],
    },
    {
        "target": ".product-selector",
        "codeId": "ldcl",
        "events": [
            {
                "eventTarget": ".hideProd",
                "eventType": "click",
                "tags": {
                    "componentId": "psallr",
                    "componentName": "product selector recommendations",
                    "elementText": "",
                    "elementType": "recommendation list refinement",
                    "event": "navigation",
                    "eventType": [
                        {
                            "rule": "true",
                            "value": "hide products click"
                        }
                    ],
                    "refinementCategory": "",
                    "parentName": "tabs",
                    "parentTitle": ""
                }
            },
        ]
    },
    // Recommendation wizard
    {
        "target": ".recommendations-wizard",
        "codeId": "psil",
        "events": [
            {
                "eventTarget": ".view-recommendations",
                "eventType": "click",
                "tags": {
                    "componentId": "psil",
                    "componentName": "industrial lubricant selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "recommendations wizard button",
                    "event": "product",
                    "eventType": "recommendations wizard internal navigation click"
                }
            },
            {
                "eventTarget": "a:not(.view-recommendations)",
                "eventType": "click",
                "tags": {
                    "componentId": "psil",
                    "componentName": "industrial lubricant selector",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "recommendations wizard drilldown link",
                    "event": "product",
                    "eventType": "recommendations wizard drilldown click",
                    "listOrdinal": {
                        "ref": ".lists",
                        "ele": "li a"
                    },
                    "titleText": ""
                }
            }
        ]
    },
    {
        "target": "searchInputClickLocator",
        "events": [
            {
                "eventTarget": "SearchBoxSearchLocator",
                "eventType": "click",
                "tags": {
                    "componentId": "lsb",
                    "componentName": "locator search box",
                    "elementText": "",
                    "elementType": "locator search box",
                    "event": "locator",
                    "eventType": "locator search submit",
                    "searchSubType": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
        ]
    }
)